import largestRemainder from '../../../util/numbers/largestRemainder';

/**
 * Função que formata os dados dos resultados percentuais para 1 casa decimal
 * @param data dados do gráfico evolutivo
 * @param percentage porcentagem a qual a soma de todas as outrasa devem totalizar
 */
export function formatEvolutiveData(data = [], percentage = 100) {
  if (data === null) {
    return;
  }
  return data.map((atual) => {
    /**
     * caso a pesquisa possua dados previstos a soma pode não resultar 100%,
     * então não aplicamos o largest remainder aqui, apenas um arredondamento simples
     */
    const attribute = atual.hasOwnProperty("tipo_pergunta") 
      ? "tipo_pergunta" 
      : "tipoPergunta";

    const tipoPergunta = atual[attribute];

    const isMultipleQuestionType = tipoPergunta === 'MULTIPLA';

    if (isMultipleQuestionType) {
      const resultadosArredondados = atual.resultados.map((resultado) => ({
        ...resultado,
        resultadoPercentual: Math.round(resultado.resultadoPercentual),
      }));

      return {
        ...atual,
        resultados: resultadosArredondados,
      };
    }

    // Mapeia o resultado percentual para um array, para que o largest remainder possa
    // ser executado
    const array = atual.resultados.map((resultado) => resultado.resultadoPercentual);

    // Formata os valores e garante que a soma deles será igual a percentage
    const resultado_percentual = largestRemainder(percentage, array, 0);

    // Percorre os dados setando os valores formatados
    const resultados = atual.resultados.map((resultado, index) => ({ ...resultado, resultadoPercentual: resultado_percentual[index] }));
    
    console.log("[RESULTADOS EVOLUTIVOS]", { ...atual, resultados })
    return { ...atual, resultados };
  });
}
